export const MAIN_SIDEBAR_WIDTH = 150;
